module.exports = __webpack_public_path__ + "static/media/bg.564de1ff.png";